document.addEventListener("DOMContentLoaded", function() {

  window.addEventListener("load", function() {
    const rainbowUnicorn = document.querySelector('.rainbow-unicorn');

    if (rainbowUnicorn) {

      const scrollHandler = () => {
        const svg = rainbowUnicorn.querySelector('svg');

        svg.style.transform =
          `translate3d(0, ${window.scrollY / 3}px, 0)`;
      }

      window.addEventListener('scroll', scrollHandler);

      scrollHandler();
    }
  });
});

